import { Injectable, signal } from "@angular/core"
import { EventType, Router } from "@angular/router"
import { AppRoute } from "@app-types/appRoute"

@Injectable({ providedIn: 'root' }) export class RouteService {
    constructor(
        private readonly _router: Router,
    ) {
        this._router.events.subscribe(event => {
            if (event.type === EventType.NavigationEnd) {
                const path = event.urlAfterRedirects
                this._currentRoute.set({
                    path,
                    purchasingCoOp: path.split('/')[1] === AppRoute.PATHS.purchasingCoOp,
                    membership: path.split('/')[1] === AppRoute.PATHS.membership,
                })
            }
        })
    }

    private readonly _currentRoute = signal({
        path: '',
        purchasingCoOp: false,
        membership: false
    })
    readonly currentRoute = this._currentRoute.asReadonly()
}